import { useState } from "react";
import { SectionHeading } from "../components/SectionHeading";
import { RichText, useSiteTranslation } from "../i18n";
import "../styles/faq.css";

/** Accordion of questions beside a sticky heading. Defaults to the homepage copy. */
export function FaqSection({ items, id = "faq", eyebrow, title, lead }) {
  const { t } = useSiteTranslation();
  const questions = items || t("home.faq.items", { returnObjects: true });
  // Only one answer is open at a time; -1 means all are closed.
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (event, index) => {
    event.preventDefault();
    setOpenIndex((open) => (open === index ? -1 : index));
  };

  return (
    <section className="section faq" id={id}>
      <div className="wrap faq-grid">
        <SectionHeading
          layout="faq"
          eyebrow={eyebrow ?? t("home.faq.eyebrow")}
          title={title ?? <RichText k="home.faq.title" />}
          lead={lead ?? t("home.faq.lead")}
        />
        <div className="faq-list" data-reveal>
          {questions.map(({ q, a }, index) => (
            <details key={q} open={openIndex === index}>
              <summary onClick={(event) => toggle(event, index)}>
                {q}
                <span />
              </summary>
              <p>{a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
